export const USER = 'USER';
export const QUESTION = 'QUESTION';
export const NOTIFICATION = 'NOTIFICATION';
export const SIDE_PAGE = 'SIDE_PAGE';
export const CURRENTCHAT = 'CURRENTCHAT';
export const CHAT = 'CHAT';
export const ROOMS = 'ROOMS';
export const MESSAGE_HISTORY='MESSAGE_HISTORY'
